import * as React from 'react';
import { Column } from '../layout/Column';
import { MainGrid } from '../layout/MainGrid';
import { Card } from '../shared/card/Card';
import { Icon } from '../shared/Icon';

const AccessDenied = (): React.ReactElement => {
  return (
    <MainGrid style={{ height: '100%' }}>
      <Card>
        <Column style={{ alignItems: 'center', justifyContent: 'center' }}>
          <Icon name='block' size='large' />
          <h1>Access Denied</h1>
          <h5>
            Check with your Org Administrator if you believe you should have
            access to this team.
          </h5>
        </Column>
      </Card>
    </MainGrid>
  );
};

export { AccessDenied };
